import * as mutation_types from "./mutation_types";

export default {
  [mutation_types.M_SET_SEARCHED](state, payload) {
    state.searched = payload;
  },
  [mutation_types.M_SET_SEARCH_RESULT](state, payload) {
    state.searchResult = payload;
  },
  [mutation_types.M_SET_API_URL](state, payload) {
    state.API_URL = payload;
  },
  [mutation_types.M_SET_API_ORIGIN](state, payload) {
    state.API_ORIGIN = payload;
  },
  [mutation_types.M_SET_QUOTA_DESCRIPTION](state, payload) {
    state.quotaDescription = payload;
  },
  [mutation_types.M_SET_DATES_ISO](state, payload) {
    state.datesISO = payload;
  },
  [mutation_types.M_SET_SHOW_QUOTES](state, payload) {
    state.showQuotes = payload;
  }
};
